import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import intlShape from '@/shared/utils/intlShape';
import FormGroupPart from './FormGroupPart';
import messages from '../registrationMessages';
import PriceOptionsDropdown from './PriceOptionsDropdown';
import InputGroupWrapper from '../../InputGroupWrapper';
import CurrencySymbol from '../../CurrencySymbol';
import { priceShape } from '../registrationHelpers';
import NumberInput from '../../input/NumberInput';

const UnitPricePart = ({
  unitPrice,
  price,
  priceOptions,
  isFixedPrice,
  intl,
  disabled,
  onUnitPriceChanged,
  onPriceChanged,
  className,
}) => {
  const showPriceOptions =
    priceOptions &&
    priceOptions.length > 0 &&
    (!price || !price.id || price.amount !== priceOptions[0].amount);

  return (
    <FormGroupPart label={messages.Price}>
      <InputGroupWrapper
        className={classnames('input-group-sm', { disabled: disabled }, className)}
        left={<CurrencySymbol />}
        right={
          showPriceOptions ? (
            <PriceOptionsDropdown
              price={price}
              priceOptions={priceOptions}
              disabled={disabled}
              onPriceChanged={onPriceChanged}
            />
          ) : null
        }
        rightClassName="input-group-btn"
      >
        <NumberInput
          id="unitPriceField"
          min={0}
          disabled={disabled}
          value={unitPrice}
          onChange={onUnitPriceChanged}
          className="form-control input-sm"
        />
        {isFixedPrice ? (
          <span
            className="input-group-addon"
            title={intl.formatMessage(messages.ResourceFixedPriceTooltip)}
          >
            <i className="fa fa-info" />
          </span>
        ) : null}
      </InputGroupWrapper>
    </FormGroupPart>
  );
};

UnitPricePart.propTypes = {
  unitPrice: PropTypes.number,
  price: priceShape,
  priceOptions: PropTypes.arrayOf(priceShape),
  isFixedPrice: PropTypes.bool,
  disabled: PropTypes.bool,
  intl: intlShape.isRequired,
  onUnitPriceChanged: PropTypes.func.isRequired,
  onPriceChanged: PropTypes.func,
  className: PropTypes.string,
};
UnitPricePart.defaultProps = {
  unitPrice: 0,
  price: null,
  priceOptions: null,
  isFixedPrice: false,
  disabled: false,
  onPriceChanged: () => {},
  className: '',
};
export default UnitPricePart;
